// Селекторы для gameState

// Базовые селекторы

export const selectPrivateState = (state) => state.private;
export const selectToastState = (state) => selectPrivateState(state).toast;
export const selectGoblinsTrapKillNoticeState = (state) => selectPrivateState(state).goblinsTrapKillNotice;
// Слепки промежуточных итогов на конец текущего и предыдущего раундов (см. RoundEndModal)
export const selectRoundStandingsState = (state) => selectPrivateState(state).roundStandings;
// Последняя покупка политики для тоста в матче (см. MatchPolicyToast)
export const selectPolicyPurchase = (state) => selectPrivateState(state).policyToast.purchase;
export const selectLayersState = (state) => selectPrivateState(state).layers;
export const selectUnitsVisible = (state) => selectLayersState(state).unitsVisible;
export const selectHexCoordinatesVisible = (state) => selectLayersState(state).hexCoordinatesVisible;
export const selectKeyPointIncomeVisible = (state) => selectLayersState(state).incomeVisible;
export const selectCityOwnershipVisible = (state) => selectLayersState(state).cityOwnershipVisible;
export const selectBlockedCellsVisible = (state) => selectLayersState(state).blockedCellsVisible;
export const selectGuildVisible = (state) => selectLayersState(state).guildVisible;
export const selectTempleVisible = (state) => selectLayersState(state).templeVisible;
export const selectFortressVisible = (state) => selectLayersState(state).fortressVisible;
export const selectQuarterZoneVisible = (state) => selectLayersState(state).quarterZoneVisible;
export const selectModalVisibilityState = (state) => selectPrivateState(state).modalVisibility;
export const selectHideModalsExceptGameEnd = (state) => selectModalVisibilityState(state).hideModalsExceptGameEnd;
export const selectShowRoundEndModal = (state) =>
  !selectHideModalsExceptGameEnd(state) && selectModalVisibilityState(state).showRoundEndModal;
export const selectShowCityCaptureModal = (state) =>
  !selectHideModalsExceptGameEnd(state) && selectModalVisibilityState(state).showCityCaptureModal;
export const selectIsCityCaptureAnimationPlaying = (state) =>
  Boolean(selectModalVisibilityState(state)?.isCityCaptureAnimationPlaying);
export const selectIsRuinsIncomeAnimationPending = (state) =>
  Boolean(selectModalVisibilityState(state)?.isRuinsIncomeAnimationPending);
export const selectIsRuinsIncomeAnimationPlaying = (state) =>
  Boolean(selectModalVisibilityState(state)?.isRuinsIncomeAnimationPlaying);
// Анимация дохода руин еще впереди или идет: снабжение, свечение руин и оверлей
// хода показываются после нее
export const selectIsRuinsIncomeAnimationAwaited = (state) =>
  selectIsRuinsIncomeAnimationPending(state) || selectIsRuinsIncomeAnimationPlaying(state);
// Поле показывает заставку (облет захваченных городов, рост дохода руин):
// никто не ходит, панели погашены, в шапке — что сейчас происходит
export const selectIsFieldCutscenePlaying = (state) =>
  selectIsCityCaptureAnimationPlaying(state) || selectIsRuinsIncomeAnimationPlaying(state);
export const selectIsUnitDeathAnimationPlaying = (state) =>
  Boolean(selectModalVisibilityState(state)?.isUnitDeathAnimationPlaying);
export const selectShowCombatResultsModal = (state) =>
  !selectHideModalsExceptGameEnd(state) && selectModalVisibilityState(state).showCombatResultsModal;
export const selectCombatResultsMeleeHold = (state) => selectModalVisibilityState(state)?.combatResultsMeleeHold || null;
export const selectCarriedCombatResults = (state) => selectModalVisibilityState(state)?.carriedCombatResults || null;
export const selectShowGameEndModal = (state) => selectModalVisibilityState(state).showGameEndModal;
export const selectShowInitiativeModal = (state) =>
  !selectHideModalsExceptGameEnd(state) && selectModalVisibilityState(state).showInitiativeModal;
export const selectShowRepairBuildingModal = (state) =>
  !selectHideModalsExceptGameEnd(state) && selectModalVisibilityState(state).showRepairBuildingModal;
export const selectRepairBuildingHexKey = (state) => selectModalVisibilityState(state).repairBuildingHexKey;
export const selectRepairBuildingPlayerId = (state) => selectModalVisibilityState(state).repairBuildingPlayerId;
export const selectShowNoConstructionActionsModal = (state) =>
  !selectHideModalsExceptGameEnd(state) && selectModalVisibilityState(state).showNoConstructionActionsModal;
export const selectShowSupplyFarmsConfirmModal = (state) =>
  !selectHideModalsExceptGameEnd(state) && selectModalVisibilityState(state).showSupplyFarmsConfirmModal;
export const selectShowSupplyRedistributeConfirmModal = (state) =>
  !selectHideModalsExceptGameEnd(state) && selectModalVisibilityState(state).showSupplyRedistributeConfirmModal;
export const selectShowWarStageUnitsConfirmModal = (state) =>
  !selectHideModalsExceptGameEnd(state) && selectModalVisibilityState(state).showWarStageUnitsConfirmModal;
export const selectShowIsolationismModal = (state) =>
  !selectHideModalsExceptGameEnd(state) && selectModalVisibilityState(state).showIsolationismModal;
// Правила игрок открывает САМ — кнопкой в шапке, инфо-кнопкой футера или из
// панели осмотра клетки, и настройка «не отображать всплывающие окна» их не
// касается: она про окна, которые выскакивают по ходу партии. Раньше гейт был
// незаметен, потому что настройку поднимал только зритель, а теперь с ней же
// стартует партия из одних ботов — и зритель такой партии оставался бы без
// правил, хотя кнопки перед ним нарисованы
export const selectShowConstructionPhaseInfoModal = (state) =>
  selectModalVisibilityState(state).showConstructionPhaseInfoModal;
export const selectInitialRulesSectionId = (state) => selectModalVisibilityState(state).initialRulesSectionId;
export const selectRulesActiveSectionId = (state) => selectModalVisibilityState(state).rulesActiveSectionId;

export const selectCombatState = (state) => selectPrivateState(state).combat;
export const selectShowMeleeTargets = (state) => selectCombatState(state).showMeleeTargets;

export const selectAuthState = (state) => selectPrivateState(state).auth;
export const selectUserName = (state) => selectAuthState(state).name;
export const selectUserId = (state) => selectAuthState(state).id;
export const selectFactionLoadouts = (state) => selectAuthState(state).factionLoadouts;
export const selectUnitSkins = (state) => selectAuthState(state).unitSkins;

export const selectLobbyState = (state) => selectPrivateState(state).lobby;
export const selectLobbyId = (state) => selectLobbyState(state).lobbyId;
export const selectLobbyPlayers = (state) => selectLobbyState(state).players;
export const selectLobbyCreatorId = (state) => selectLobbyState(state).creatorId;

export const selectServerTimeState = (state) => selectPrivateState(state).serverTime;
export const selectServerTimeDelta = (state) => selectServerTimeState(state).serverTimeDelta;

// === Блокировка ввода после нуля таймера хода (см. turnInputLockReducer) ===
// Защитно: состояния, собранные вручную (тесты, серверные обертки стора), могут
// не содержать этого среза. Действует ли блокировка — selectIsTurnInputLocked в
// utils/gameState/turn/turnInputLock: для этого нужно и общее состояние партии
const EMPTY_TURN_INPUT_LOCK = Object.freeze({
  lockedTurnKey: null,
  releasedTurnKey: null,
  isAwaitingServerTimestamp: false,
});
export const selectTurnInputLockState = (state) => state?.private?.turnInputLock || EMPTY_TURN_INPUT_LOCK;
export const selectReleasedTurnInputKey = (state) => selectTurnInputLockState(state).releasedTurnKey;
export const selectIsAwaitingServerTurnTimestamp = (state) => selectTurnInputLockState(state).isAwaitingServerTimestamp;

// === Автовыбор отрядов и пропуски хода (см. unitAutoSelectionReducer) ===
const EMPTY_UNIT_AUTO_SELECTION = Object.freeze({skipKey: null, skippedUnitIds: Object.freeze([]), isEnabled: true});
export const selectUnitAutoSelectionState = (state) => state?.private?.unitAutoSelection || EMPTY_UNIT_AUTO_SELECTION;
export const selectIsUnitAutoSelectionEnabled = (state) => selectUnitAutoSelectionState(state).isEnabled;

export const selectedSelectedEntitiesState = (state) => selectPrivateState(state).selectedEntities;
export const selectSelectedUnitId = (state) => selectedSelectedEntitiesState(state).selectedUnitId;
export const selectSelectedFarmHexKey = (state) => selectedSelectedEntitiesState(state).selectedFarmHexKey;
export const selectIsFarmAutoSelected = (state) => Boolean(selectedSelectedEntitiesState(state).isFarmAutoSelected);
export const selectSupplyAutoFarmDeclinedTurn = (state) => selectedSelectedEntitiesState(state).supplyAutoFarmDeclinedTurn;
export const selectSelectedBarracksHexKey = (state) => selectedSelectedEntitiesState(state).selectedBarracksHexKey;
export const selectSelectedToken = (state) => selectedSelectedEntitiesState(state).selectedToken;
export const selectDestructionToolActive = (state) => selectedSelectedEntitiesState(state).destructionToolActive
export const selectInspectedHexKey = (state) => selectedSelectedEntitiesState(state).inspectedHexKey;
export const selectGoblinsAbilityMode = (state) => selectedSelectedEntitiesState(state).goblinsAbilityMode;

export const selectReactionsState = (state) => selectPrivateState(state).reactions;
export const selectReactionQueue = (state) => selectReactionsState(state).queue;
export const selectMutedReactionPlayerIds = (state) => selectReactionsState(state).mutedPlayerIds;

// === Сюжетные миссии (редактор и прохождение) ===
export const selectMissionState = (state) => state.private.mission;
export const selectIsMissionEditorMode = (state) => selectMissionState(state).isEditorMode;
export const selectMissionId = (state) => selectMissionState(state).missionId;
export const selectIsMissionActive = (state) => Boolean(selectMissionState(state).missionId)
  || selectMissionState(state).isEditorMode;
export const selectMissionScript = (state) => selectMissionState(state).script;
export const selectMissionScriptIndex = (state) => selectMissionState(state).scriptIndex;
export const selectMissionAutoBotColors = (state) => selectMissionState(state).autoBotColors;
export const selectMissionActiveObjectives = (state) => selectMissionState(state).activeObjectives;
export const selectMissionCompletedObjectiveIds = (state) => selectMissionState(state).completedObjectiveIds;
export const selectMissionActiveReplica = (state) => selectMissionState(state).activeReplica;
export const selectMissionDraft = (state) => selectMissionState(state).draft;
export const selectMissionCharacterImages = (state) => selectMissionState(state).characterImages;
export const selectIsMissionFinished = (state) => selectMissionState(state).isMissionCompleted;
export const selectIsMissionFailed = (state) => selectMissionState(state).isMissionFailed;

// === Планирование строительства в сетевой игре (см. constructionPlanReducer) ===
// Защитно: состояния, собранные вручную (тесты, серверные обертки стора), могут
// не содержать этого среза
const EMPTY_CONSTRUCTION_PLAN = Object.freeze({
  entries: Object.freeze([]),
  brushToken: null,
  appliedTurnKey: null,
  isAutoCompleteTurn: false,
  invalidHexKeys: Object.freeze([]),
});
export const selectConstructionPlanState = (state) => state?.private?.constructionPlan || EMPTY_CONSTRUCTION_PLAN;
export const selectConstructionPlanEntries = (state) => selectConstructionPlanState(state).entries;
export const selectConstructionPlanBrushToken = (state) => selectConstructionPlanState(state).brushToken;
export const selectConstructionPlanAppliedTurnKey = (state) => selectConstructionPlanState(state).appliedTurnKey;
export const selectConstructionPlanIsAutoCompleteTurn = (state) => Boolean(selectConstructionPlanState(state).isAutoCompleteTurn);
export const selectConstructionPlanInvalidHexKeys = (state) => (
  selectConstructionPlanState(state).invalidHexKeys || EMPTY_CONSTRUCTION_PLAN.invalidHexKeys
);

// === Обучение ===
export const selectTutorialState = (state) => state.private.tutorial;
export const selectTutorialChapterId = (state) => selectTutorialState(state).chapterId;
export const selectIsTutorialActive = (state) => Boolean(selectTutorialState(state).chapterId);
export const selectTutorialStepIndex = (state) => selectTutorialState(state).stepIndex;
export const selectTutorialActiveModalId = (state) => selectTutorialState(state).activeModalId;
export const selectIsTutorialChapterCompleted = (state) => selectTutorialState(state).isChapterCompleted;
export const selectIsTutorialRepeatRun = (state) => Boolean(selectTutorialState(state).isRepeatRun);
export const selectTutorialReplayMeta = (state) => selectTutorialState(state).replayMeta ?? null;

/**
 * Сколько всего партий сыграл игрок: локальные против ботов плюс сетевые — то
 * же, что gamesPlayed на сервере (рейтинговые и обычные). null — счетчики
 * неизвестны (гость, старый сервер)
 */
export const selectTotalGamesPlayed = (state) => {
  const {localGamesPlayed, onlineGamesPlayed} = selectAuthState(state);
  if (localGamesPlayed == null && onlineGamesPlayed == null) {
    return null;
  }
  return (localGamesPlayed ?? 0) + (onlineGamesPlayed ?? 0);
};
